import Vuex from 'vuex';
import creationStore from './creation';
import completionStore from './completion';
import {ProfileVerticalResource} from '@/common/api/api-raw-types';
import {ProfileCreationFunnelMode} from '../config/steps/ProfileCreationSteps';
export default new Vuex.Store({
    modules: {
        creationStore,
        completionStore,
    },
    state: {
        funnelMode: '',
        isFunnelStrategy: false,
    },
    mutations: {
        setFunnelMode: (state, funnelMode: ProfileVerticalResource) => {
            state.funnelMode = funnelMode;
            state.isFunnelStrategy = state.funnelMode === ProfileCreationFunnelMode.STRATEGY;
        },
    },
});
